import { useTranslation } from 'module/hooks/use-translation';
import { OverflowMenuVertical } from '@carbon/icons-react';
import { DropDownProps, Tooltip } from 'antd';
import { FC } from 'react';
import { Button } from '../button';
import { Dropdown } from '../dropdown/dropdown';
import { IconWrapper } from '../icon-shell/icon-shell';

export interface MoreActionsDropdownProps extends Omit<
  DropDownProps,
  'overlay' | 'trigger'
> {
  tooltipText?: React.JSX.Element;
  dataCyValue?: string;
  hideHoverBorderRadius?: boolean;
  stopPropogation?: boolean;
  triggerElement?: React.ReactNode;
}

export const MoreActionsDropdown: FC<
  React.PropsWithChildren<MoreActionsDropdownProps>
> = ({
  menu,
  className,
  overlayClassName,
  placement = 'bottomRight',
  tooltipText,
  dataCyValue = 'buttons.more-actions',
  hideHoverBorderRadius = false,
  stopPropogation,
  triggerElement,
  ...restProps
}) => {
  const moreActionsText = useTranslation('more_actions');

  return (
    <Dropdown
      className={className}
      overlayClassName={overlayClassName}
      menu={menu}
      placement={placement}
      trigger={['click']}
      {...restProps}
    >
      <div>
        <Tooltip title={tooltipText ?? moreActionsText}>
          <div>
            {triggerElement !== undefined ? (
              triggerElement
            ) : (
              <Button
                type="text"
                icon={
                  <IconWrapper>
                    <OverflowMenuVertical size={16} />
                  </IconWrapper>
                }
                onClick={(e) => {
                  if (stopPropogation) {
                    e.stopPropagation();
                  }
                }}
                size="small"
                data-cy={dataCyValue}
                hideHoverBorderRadius={hideHoverBorderRadius}
              />
            )}
          </div>
        </Tooltip>
      </div>
    </Dropdown>
  );
};
